import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createSelector } from 'reselect';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import messages from './messages';
import style from './order-templates.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const handleShipmentNotificationClick = createSelector(
  (onShipmentNotificationSelected) => onShipmentNotificationSelected,
  (_, shipmentEmailTemplate) => shipmentEmailTemplate,
  (onShipmentNotificationSelected, shipmentEmailTemplate) => () => onShipmentNotificationSelected(shipmentEmailTemplate),
);

const ShipmentNotificationSelector = ({ selected, onShipmentNotificationSelected, shipmentTemplates = emptyArray }) => {
  return (
    <div className={classnames(style['select-container'], 'select-container')}>
      <label className={style['select-label']}>
        <FormattedMessage {...messages.shipmentNotificationLabel} />
      </label>
      <DropdownMenu className={style['select-dropdown-menu']} dropdownMenuShouldHaveWidthOfButton>
        <DropdownMenuToggler theme='white'>
          {selected && selected.name}
          {!selected && <FormattedMessage {...messages.shipmentNotificationDefault} />}
        </DropdownMenuToggler>
        {shipmentTemplates.map((notification) => (
          <DropdownMenuItem
            key={notification.name}
            onClick={handleShipmentNotificationClick(onShipmentNotificationSelected, notification)}
            selected={selected && notification.name === selected.name}
          >
            {notification.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

ShipmentNotificationSelector.propTypes = {
  selected: PropTypes.object.isRequired,
  onShipmentNotificationSelected: PropTypes.func.isRequired,
  shipmentTemplates: PropTypes.array,
};

export default ShipmentNotificationSelector;
